<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body p-3">
            <div class="card-title text-center">
              <h3>Malware Search</h3>
            </div>
            <p class="card-title-desc text-center">
              Analyse suspicious files, domains, IPs and URLs to detect malware
              and other breaches, automatically share them with the security
              community.
            </p>
            <div class="search-form px-5">
              <div class="row">
                <div class="col-xl-8 col-lg-6 col-md-4 mb-3">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Search name, hash, or IP Address .."
                  />
                </div>
                <div class="col-xl-4 col-lg-6 col-md-8">
                  <div class="row">
                    <div class="col-xl-4 col-lg-6 col-md-6 col-sm-4 mb-3">
                      <select class="custom-select">
                        <option selected>All Sandbox</option>
                        <option value="1">Checkpoint</option>
                        <option value="2">AhnLab</option>
                      </select>
                    </div>
                    <div class="col-xl-4 col-lg-3 col-md-3 col-sm-6 mb-3">
                      <b-button variant="primary" class="btn-block">
                        <i class="bx bx-search font-size-16 align-middle"></i>
                        <span class="d-xl-inline d-lg-none d-md-none"
                          >Search</span
                        >
                      </b-button>
                    </div>
                    <div class="col-xl-4 col-lg-3 col-md-3 col-sm-2 mb-3">
                      <b-button
                        variant="outline-primary"
                        class="btn-block"
                        v-b-toggle="'advanced-search'"
                      >
                        <i class="bx bx-filter font-size-16 align-middle"></i>
                        <span class="d-xl-inline d-lg-none d-md-none d-sm-none"
                          >Advanced</span
                        >
                      </b-button>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <b-collapse id="advanced-search" class="mt-1">
                    <hr class="mt-4 mb-0" />
                    <div class="py-4">
                      <div class="row">
                        <div class="col-12 col-sm-6 col-md-6 col-lg-3">
                          <div class="form-group">
                            <label for="validationCustom01">File Name</label>
                            <input
                              id="validationCustom01"
                              type="text"
                              class="form-control"
                              placeholder="example.exe"
                            />
                          </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 col-lg-3">
                          <div class="form-group">
                            <label for="validationCustom01">Threat Name</label>
                            <input
                              id="validationCustom01"
                              type="text"
                              class="form-control"
                              placeholder="Trojan.mW"
                            />
                          </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 col-lg-3">
                          <div class="form-group">
                            <label for="validationCustom01">File Type</label>
                            <input
                              id="validationCustom01"
                              type="text"
                              class="form-control"
                              placeholder="exe"
                            />
                          </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 col-lg-3">
                          <div class="form-group">
                            <label for="validationCustom01">IP Address</label>
                            <input
                              id="validationCustom01"
                              type="text"
                              class="form-control"
                              placeholder="10.10.xx.xxx"
                            />
                          </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6">
                          <div class="form-group">
                            <label for="validationCustom01">MD5</label>
                            <input
                              id="validationCustom01"
                              type="text"
                              class="form-control"
                              placeholder="c0d5b1cc0c77fcf32ff02aac98fac536"
                            />
                          </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6">
                          <div class="form-group">
                            <label for="validationCustom01">SHA-1</label>
                            <input
                              id="validationCustom01"
                              type="text"
                              class="form-control"
                              placeholder="2154845e38fc348ae1be419684f9572a680fabfd"
                            />
                          </div>
                        </div>
                        <div class="col-12 text-right">
                          <b-button variant="primary" class="px-5">
                            <i
                              class="
                                bx bx-search
                                font-size-16
                                align-middle
                                mr-2
                              "
                            ></i>
                            Search
                          </b-button>
                        </div>
                      </div>
                    </div>
                  </b-collapse>
                </div>
              </div>
            </div>
            <div class="text-center mt-4">
              <!-- <button type="button" class="btn btn-primary mx-1">Upload</button>
              <button type="button" class="btn btn-secondary mx-1">
                Cancel
              </button> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="card-title">
          <div class="d-flex">
            <div class="">
              <h4>Checkpoint Result</h4>
              <p class="font-size-12 font-weight-normal">1 result found</p>
            </div>
          </div>
        </div>
        <div class="d-block bg-primary rounded py-3 px-2">
          <h5 class="text-white mb-0">
            Hash :
            e68f38195b3c816309882388c23118327ec97f9ad775bf59b9a8a3089dd68fd8
          </h5>
        </div>
        <div class="d-block rounded py-4 px-2 border mt-3">
          <div class="row">
            <div class="col-lg-6">
              <div class="row">
                <div class="col-lg-6">
                  <label for="">Threat Name</label>
                  <p>Lask.jp</p>
                </div>
                <div class="col-lg-6">
                  <label for="">File Name</label>
                  <p>Evgeny_CV_m.pdf</p>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="row">
                <div class="col-3">
                  <label for="">File Size</label>
                  <p>213.3 Kb</p>
                </div>
                <div class="col-3">
                  <label for="">Index Time</label>
                  <p class="mb-0">2020-03-29 14:01:13</p>
                  <p class="font-italic mb-0">2 Year Ago</p>
                </div>
                <div class="col-3">
                  <label for="">File Type</label>
                  <p>PDF</p>
                </div>
                <div class="col-3">
                  <div class="avatar-lg">
                    <span
                      class="
                        avatar-title
                        rounded-circle
                        bg-light
                        text-danger
                        font-size-16
                      "
                    >
                      <i class="bx bxs-file-pdf bx-lg"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <b-tabs nav-class="nav-tabs-custom mt-4" content-class="p-3 text-muted">
          <b-tab active>
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="fas fa-home"></i>
              </span>
              <span class="d-none d-sm-inline-block px-4">Details</span>
            </template>
            <div class="table-responsive">
              <table class="table mb-0">
                <tbody>
                  <tr class="bg-light">
                    <th colspan="2">Basic Properties</th>
                  </tr>
                  <tr>
                    <td width="20%">MD5</td>
                    <td>c0d5b1cc0c77fcf32ff02aac98fac536</td>
                  </tr>
                  <tr>
                    <td>SHA-1</td>
                    <td>2154845e38fc348ae1be419684f9572a680fabfd</td>
                  </tr>
                  <tr>
                    <td>SHA-256</td>
                    <td>
                      e68f38195b3c816309882388c23118327ec97f9ad775bf59b9a8a3089dd68fd8
                    </td>
                  </tr>
                  <tr>
                    <td>File Type</td>
                    <td>PDF</td>
                  </tr>
                  <tr>
                    <td>File Size</td>
                    <td>213.34 Kb ( 213354 Byte )</td>
                  </tr>
                  <tr class="bg-light">
                    <th colspan="2">History</th>
                  </tr>
                  <tr>
                    <td width="20%">First Submitted</td>
                    <td>2020-03-29 14:01:13</td>
                  </tr>
                  <tr>
                    <td>Last Updated</td>
                    <td>2020-03-29 20:47:49</td>
                  </tr>
                  <tr>
                    <td>Last Analysis</td>
                    <td>2020-03-29 20:47:49</td>
                  </tr>
                  <tr class="bg-light">
                    <th colspan="2">Names</th>
                  </tr>
                  <tr>
                    <td>File Name</td>
                    <td>Evgeny_CV_m.pdf</td>
                  </tr>
                  <tr>
                    <td>Threat Name</td>
                    <td>N/A</td>
                  </tr>
                  <tr>
                    <td>Classification</td>
                    <td>Trojan.Mw</td>
                  </tr>
                  <tr>
                    <td>Severity</td>
                    <td>Critical</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-tab>
          <b-tab>
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="far fa-envelope"></i>
              </span>
              <span class="d-none d-sm-inline-block px-4"
                >IP Reputation & Whois</span
              >
            </template>
            <div class="row">
              <div class="col-6">
                <h5>IP Reputation</h5>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="input-group mb-2 currency-value">
                      <div class="input-group-prepend">
                        <span class="input-group-text">IP Source</span>
                      </div>
                      <input
                        type="text"
                        class="form-control bg-light text-center"
                        value="10.13.23.44"
                        disabled
                      />
                    </div>
                  </div>

                  <div class="col-sm-6">
                    <div class="input-group mb-2">
                      <input
                        type="text"
                        class="form-control bg-light text-center"
                        value="194.29.36.43"
                        disabled
                      />

                      <div class="input-group-append">
                        <span class="input-group-text">IP Destination</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="table-responsive">
                  <table class="table mb-0">
                    <tbody>
                      <tr>
                        <th>Select IP</th>
                        <th>194.29.36.43</th>
                      </tr>
                      <tr class="bg-light">
                        <th colspan="2">Geo IP</th>
                      </tr>
                      <tr>
                        <td width="20%">Country</td>
                        <td>Israel</td>
                      </tr>
                      <tr>
                        <td>Country Code</td>
                        <td>IL</td>
                      </tr>
                      <tr>
                        <td>Country Calling Code</td>
                        <td>972</td>
                      </tr>
                      <tr>
                        <td>Continent</td>
                        <td>Asia</td>
                      </tr>
                      <tr>
                        <td>City</td>
                        <td>Tel Aviv</td>
                      </tr>
                      <tr>
                        <td>Postal Code</td>
                        <td>N/A</td>
                      </tr>
                      <tr>
                        <td>Region</td>
                        <td>Tel Aviv</td>
                      </tr>
                      <tr>
                        <td>Region Code</td>
                        <td>TA</td>
                      </tr>
                      <tr>
                        <td>Currency</td>
                        <td>Israeli New Sheqel</td>
                      </tr>
                      <tr>
                        <td>Location</td>
                        <td>
                          <b-button size="sm" variant="primary">
                            <i
                              class="
                                bx bx-map-pin
                                font-size-16
                                align-middle
                                mr-2
                              "
                            ></i>
                            Show Map
                          </b-button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="col-6">
                <h5>Whois Lookup</h5>
              </div>
            </div>
          </b-tab>
          <b-tab>
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="far fa-envelope"></i>
              </span>
              <span class="d-none d-sm-inline-block px-4">Related</span>
            </template>
            {{ text }}
          </b-tab>
          <b-tab>
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="fas fa-cog"></i>
              </span>
              <span class="d-none d-sm-inline-block px-4">Report Analysis</span>
            </template>
            {{ content }}
          </b-tab>
        </b-tabs>
      </div>
    </div>

    <!-- <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="card-title mb-4">
              <div class="d-flex align-items-center justify-content-between">
                <h4 class="card-title">Malware Data</h4>
                <div class="d-flex align-items-center">
                  <div class="search-box">
                    <div class="position-relative">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Search..."
                      />
                      <i class="bx bx-search-alt search-icon"></i>
                    </div>
                  </div>
                  <button class="btn btn-outline-secondary btn-rounded ml-2">
                    <i class="bx bx-filter font-size-16 align-middle"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="table-responsive mb-0">
              <table class="table table-centered table-nowrap">
                <thead class="thead-light">
                  <tr>
                    <th>#</th>
                    <th>Uploader</th>
                    <th>Threat Name</th>
                    <th>MD5</th>
                    <th>SHA-1</th>
                    <th>Filename</th>
                    <th>Size</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(data, idx) in malware" :key="idx">
                    <td>{{ idx + 1 }}</td>
                    <td>
                      <div class="avatar-sm">
                        <img
                          src="@/assets/images/users/avatar-10.jpg"
                          alt
                          class="img-thumbnail rounded-circle"
                        />
                      </div>
                      {{ data.uploader }}
                    </td>
                    <td>
                      <p class="p-0 m-0 mb-2 font-weight-bolder">
                        <span
                          v-if="data.th_name"
                          class="
                            font-size-12
                            badge badge-danger
                            p-2
                            font-italic
                          "
                        >
                          {{ data.th_name }}
                        </span>
                        <span v-else> -- </span>
                      </p>
                      <span class="font-weight-bold">Tags : </span>
                      <span v-if="data.tags.length != 0">
                        <span
                          v-for="tag in data.tags"
                          :key="tag"
                          class="
                            badge badge-pill badge-soft-info
                            font-size-12
                            mr-1
                          "
                          >{{ tag }}</span
                        >
                      </span>
                      <span v-else>--</span>
                    </td>
                    <td>
                      <i class="bx bxs-lock mr-1"></i>
                      <u>{{ data.md5 }}</u>
                    </td>
                    <td>
                      <i class="bx bxs-lock mr-1"></i>
                      <u>{{ data.sha }}</u>
                    </td>
                    <td>
                      <span class="text-primary">{{ data.filename }}</span>
                    </td>
                    <td>
                      {{ data.size }}
                    </td>
                    <td>
                      <button
                        type="button"
                        class="btn btn-info btn-sm btn-rounded mr-1"
                      >
                        <i class="fas fa-eye"></i>
                      </button>
                      <button
                        type="button"
                        class="btn btn-success btn-sm btn-rounded mr-1"
                      >
                        <i class="fas fa-pencil-alt"></i>
                      </button>
                      <button
                        type="button"
                        class="btn btn-danger btn-sm btn-rounded mr-1"
                      >
                        <i class="fas fa-trash"></i>
                      </button>
                      <button
                        type="button"
                        class="btn btn-primary btn-sm btn-rounded mr-1"
                      >
                        <i class="fas fa-download"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row">
              <div class="col-lg-12">
                <ul
                  class="pagination pagination-rounded justify-content-end mt-4"
                >
                  <li class="page-item disabled">
                    <a href="javascript: void(0);" class="page-link">
                      <i class="mdi mdi-chevron-left"></i>
                    </a>
                  </li>
                  <li class="page-item active">
                    <a href="javascript: void(0);" class="page-link">1</a>
                  </li>
                  <li class="page-item">
                    <a href="javascript: void(0);" class="page-link">2</a>
                  </li>
                  <li class="page-item">
                    <a href="javascript: void(0);" class="page-link">3</a>
                  </li>
                  <li class="page-item">
                    <a href="javascript: void(0);" class="page-link">4</a>
                  </li>
                  <li class="page-item">
                    <a href="javascript: void(0);" class="page-link">5</a>
                  </li>
                  <li class="page-item">
                    <a href="javascript: void(0);" class="page-link">
                      <i class="mdi mdi-chevron-right"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <!-- <div class="row mb-1">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="card-title mb-4">
              <div class="d-flex align-items-center justify-content-between">
                <h4 class="card-title">Queue Malware Analysis</h4>
                <div class="d-flex align-items-center">
                  <div class="search-box">
                    <div class="position-relative">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Search..."
                      />
                      <i class="bx bx-search-alt search-icon"></i>
                    </div>
                  </div>
                  <button class="btn btn-outline-secondary btn-rounded ml-2">
                    <i class="bx bx-filter font-size-16 align-middle"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="table-responsive mb-0">
              <table class="table table-centered table-nowrap">
                <thead class="thead-light">
                  <tr>
                    <th>#</th>
                    <th>User</th>
                    <th>Last Seen</th>
                    <th>Threat Name</th>
                    <th>MD5</th>
                    <th>SHA -1</th>
                    <th>FIlename</th>
                    <th>Size</th>
                    <th>Progress</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(data, idx) in queue" :key="data.id">
                    <td>
                      {{ idx + 1 }}
                    </td>
                    <td>
                      <i :class="`bx ${data.users[0]} mr-1`"></i>
                      {{ data.users[1] }}
                    </td>
                    <td>{{ data.date }}</td>
                    <td>
                      <span
                        class="badge badge-pill badge-success font-size-12"
                        :class="{
                          'badge-info':
                            `${data.status}` === 'PUP.Optional.PCVARK',
                          'badge-warning': `${data.status}` === 'Tr.VPNFilter',
                          'badge-danger': `${data.status}` === 'Ransom.SynAck',
                        }"
                        >{{ data.status }}</span
                      >
                    </td>
                    <td>{{ data.md5 }}</td>
                    <td>{{ data.sha }}</td>
                    <td>
                      <a href="#">{{ data.name }}</a>
                    </td>
                    <td>
                      {{ data.size }}
                    </td>

                    <td>
                      <button
                        type="button"
                        class="btn btn-info btn-sm btn-rounded mr-1"
                        v-if="data.progress == 1"
                      >
                        VT
                      </button>
                      <button
                        type="button"
                        class="btn btn-secondary btn-sm btn-rounded mr-1"
                        v-else
                      >
                        VT
                      </button>
                      <button
                        type="button"
                        class="btn btn-warning btn-sm btn-rounded mr-1"
                        v-if="data.progress == 2"
                      >
                        <i class="fa fa-spinner"></i>
                      </button>
                      <button
                        type="button"
                        class="btn btn-secondary btn-sm btn-rounded mr-1"
                        v-else
                      >
                        <i class="fa fa-spinner"></i>
                      </button>

                      <button
                        type="button"
                        class="btn btn-success btn-sm btn-rounded mr-1"
                        v-if="data.progress == 3"
                      >
                        <i class="fa fa-check"></i>
                      </button>
                      <button
                        type="button"
                        class="btn btn-secondary btn-sm btn-rounded mr-1"
                        v-else
                      >
                        <i class="fa fa-check"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row">
              <div class="col-lg-12">
                <ul
                  class="pagination pagination-rounded justify-content-end mt-4"
                >
                  <li class="page-item disabled">
                    <a href="javascript: void(0);" class="page-link">
                      <i class="mdi mdi-chevron-left"></i>
                    </a>
                  </li>
                  <li class="page-item active">
                    <a href="javascript: void(0);" class="page-link">1</a>
                  </li>
                  <li class="page-item">
                    <a href="javascript: void(0);" class="page-link">2</a>
                  </li>
                  <li class="page-item">
                    <a href="javascript: void(0);" class="page-link">3</a>
                  </li>
                  <li class="page-item">
                    <a href="javascript: void(0);" class="page-link">4</a>
                  </li>
                  <li class="page-item">
                    <a href="javascript: void(0);" class="page-link">5</a>
                  </li>
                  <li class="page-item">
                    <a href="javascript: void(0);" class="page-link">
                      <i class="mdi mdi-chevron-right"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import vue2Dropzone from "vue2-dropzone";

import { projectData } from "./data-projects";

/**
 * Projects-grid component
 */
export default {
  page: {
    title: "Report",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { vueDropzone: vue2Dropzone, Layout, PageHeader },
  data() {
    return {
      projectData: projectData,
      title: "LAB MALWARE",
      items: [
        {
          text: "Report Analysis",
          href: "/",
        },
        {
          text: "Report",
          active: true,
        },
      ],
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 150,
        maxFilesize: 0.5,
        headers: { "My-Awesome-Header": "header value" },
      },
      queue: [
        {
          id: "#SK2540",
          name: "	MS17-017_PAL.exe",
          date: "2022-12-10, 10:28:25",
          size: "2000.42 KB",
          status: "Tr.VPNFilter",
          md5: "33ab33466522d3cee9c937526577eb0e",
          sha: "0f1d4c8932c005412710bf993e94cce1d5424f45",
          users: ["bx-user", "Analys 1"],
          progress: "1",
          index: 1,
        },
        {
          id: "#SK2541",
          name: "idm crack 6_683468.exe",
          date: "2022-12-09, 10:28:25",
          size: "100.12 KB",
          status: "PUP.Optional.PCVARK",
          md5: "cf02d331d4526d24ea6dab7cd9c89319",
          sha: "a850a279584c6aac355c049bf7385806f3021ddc",
          users: ["bx-user", "Analys 2"],

          progress: "2",
          index: 2,
        },
        {
          id: "#SK2542",
          name: "wZgcZG.bin",
          date: "2022-12-08, 11:28:25",
          size: "4000.21 KB",
          status: "Ransom.SynAck",
          progress: "1",
          users: ["bx-user", "Analys 3"],
          md5: "a19d0ab25039f8e74803241c500c5f1e",
          sha: "5b0bbbcc36b523ca6fce60d3b404ca5efccfc30f",
          index: 3,
        },
        {
          id: "#SK2543",
          name: "LZgcZGsdfg.bin",
          date: "2022-12-07, 12:28:25",
          size: "250.12 KB",
          status: "Tr.VPNFilter",
          users: ["bx-user", "Analys 4"],
          progress: "3",
          md5: "f73c17d871a3e578d8defa67fd062841",
          sha: "b254c3dda5e7ff2369939faedf0eef9e25c6fd12",
          index: 4,
        },
        {
          id: "#SK2544",
          name: "pcposetup.exe",
          date: "2022-12-07, 10:28:25",
          size: "4000.24 KB",
          status: "Ransom.SynAck",
          users: ["bx-user", "Analys 5"],
          progress: "2",
          md5: "33ab33466522d3cee9c937526577eb0e",
          sha: "0f1d4c8932c005412710bf993e94cce1d5424f45",
          index: 5,
        },
      ],
      malware: [
        {
          id: "#SK2540",
          uploader: "Analys 1",
          th_name: "Trojan:Win32/Decrypter.exe",
          tags: ["trojan", "windows"],
          md5: "5f358afee76f2a74b1a3443c6012b27b",
          sha: "4ac8d962c6072b77f157c5d6459b887a658d66d5",
          filename: "iDescriptt.exe",
          size: "190.29kb",
          create_at: "",
        },
        {
          id: "#SK2541",
          uploader: "Analys 1",
          th_name: "Ransom:Win32/FileWatcher.Bm",
          tags: ["ransome"],
          md5: "5f358afee76f2a74b1a3443c6012b27b",
          sha: "9sd02962c6072b77f157c5d6459b887ap09dd546a",
          filename: "Hasher_file.exe",
          size: "2.20Mb",
          create_at: "",
        },
        {
          id: "#SK2542",
          uploader: "Analys 3",
          th_name: "",
          tags: [],
          md5: "5f358afee76f2a74b1a3443c6012b27b",
          sha: "45u78jj62c607278kl009d5d6459b88723ffg65ab",
          filename: "xyx678.so",
          size: "230.11kb",
          create_at: "",
        },
        {
          id: "#SK2543",
          uploader: "Analys 2",
          th_name: "Trojan:MSIL/TrojanDownloader",
          tags: ["trojan", "downloader", "cracker"],
          md5: "5f358afee76f2a74b1a3443c6012b27b",
          sha: "99da5g43ajj072b77f157c56y7k90887aaaf43n90",
          filename: "idm_crackcer.exe",
          size: "5.15Mb",
          create_at: "",
        },
        {
          id: "#SK2544",
          uploader: "Analys 5",
          th_name: "Trojan:AndroidOS.Spy.Act",
          tags: ["trojan", "spy"],
          md5: "5f358afee76f2a74b1a3443c6012b27b",
          sha: "81ads2v962c6072b77f157c5d6459b887a45ff1cb0",
          filename: "malware.apk",
          size: "8.30Mb",
          create_at: "",
        },
        {
          id: "#SK2545",
          uploader: "Analys 3",
          th_name: "Trojan:MSIL/Myimportant.cIml",
          tags: ["trojan", "file"],
          md5: "5f358afee76f2a74b1a3443c6012b27b",
          sha: "23g9062c6072b77f157c5d6459b887a658ddf56f01",
          filename: "important.pdf",
          size: "120Kb",
          create_at: "",
        },
        {
          id: "#SK2544323",
          uploader: "Analys 4",
          th_name: "HEUR:Backdoor.Win32.Accp",
          tags: ["windows", "backdoor"],
          md5: "5f358afee76f2a74b1a3443c6012b27b",
          sha: "8c12962c6072b77f157c5d6459b887a65f54h890a3d",
          filename: "lk9000.txt",
          size: "50.2Kb",
          create_at: "",
        },
      ],
      center: { lat: -2.687944013464189, lng: 117.81568343337175 },
      zoom: 5,
      poi: false,
      theme: "dark",
      isShow: false,
    };
  },
  methods: {
    showMap() {
      this.isShow = this.isShow ? false : true;
    },
    mapTheme() {
      let darkMode = {
        styles: [
          { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
          {
            elementType: "labels.text.stroke",
            stylers: [{ color: "#242f3e" }],
          },
          { elementType: "labels.text.fill", stylers: [{ color: "#746855" }] },
          {
            featureType: "administrative.locality",
            elementType: "labels.text.fill",
            stylers: [{ color: "#d59563" }],
          },
          {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers:
              this.poi == true
                ? [{ color: "#d59563" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "poi",
            elementType: "labels.icon",
            stylers: this.poi == true ? [] : [{ visibility: "off" }],
          },
          {
            featureType: "poi.park",
            elementType: "geometry",
            stylers:
              this.poi == true
                ? [{ color: "#d59563" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "poi.park",
            elementType: "labels.icon",
            stylers: this.poi == true ? [] : [{ visibility: "off" }],
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers:
              this.poi == true
                ? [{ color: "#d59563" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "poi.business",
            stylers:
              this.poi == true
                ? [{ color: "#d59563" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "road",
            elementType: "geometry",
            stylers: [{ color: "#38414e" }],
          },
          {
            featureType: "road",
            elementType: "geometry.stroke",
            stylers: [{ color: "#212a37" }],
          },
          {
            featureType: "road",
            elementType: "labels.text.fill",
            stylers: [{ color: "#9ca5b3" }],
          },
          {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [{ color: "#746855" }],
          },
          {
            featureType: "road.highway",
            elementType: "geometry.stroke",
            stylers: [{ color: "#1f2835" }],
          },
          {
            featureType: "road.highway",
            elementType: "labels.text.fill",
            stylers: [{ color: "#f3d19c" }],
          },
          {
            featureType: "transit",
            elementType: "geometry",
            stylers:
              this.poi == true
                ? [{ color: "#d59563" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "transit",
            elementType: "labels.icon",
            stylers: this.poi == true ? [] : [{ visibility: "off" }],
          },
          {
            featureType: "transit.station",
            elementType: "labels.text.fill",
            stylers:
              this.poi == true
                ? [{ color: "#d59563" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [{ color: "#17263c" }],
          },
          {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [{ color: "#515c6d" }],
          },
          {
            featureType: "water",
            elementType: "labels.text.stroke",
            stylers: [{ color: "#17263c" }],
          },
        ],
      };

      let lightMode = {
        styles: [
          {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers:
              this.poi == true
                ? [{ visibility: "on" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "poi",
            elementType: "labels.icon",
            stylers:
              this.poi == true
                ? [{ visibility: "on" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "poi.park",
            elementType: "geometry",
            stylers:
              this.poi == true
                ? [{ visibility: "on" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "poi.park",
            elementType: "labels.icon",
            stylers:
              this.poi == true
                ? [{ visibility: "on" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers:
              this.poi == true
                ? [{ visibility: "on" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "transit",
            elementType: "geometry",
            stylers:
              this.poi == true
                ? [{ visibility: "on" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "transit",
            elementType: "labels.icon",
            stylers:
              this.poi == true
                ? [{ visibility: "on" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "transit.station",
            elementType: "labels.text.fill",
            stylers:
              this.poi == true
                ? [{ visibility: "on" }]
                : [{ visibility: "off" }],
          },
        ],
      };

      if (this.theme != "dark") {
        return lightMode;
      } else {
        return darkMode;
      }
    },
  },
};
</script>